import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=09794fb7&"
import script from "./SecurityPage.vue?vue&type=script&lang=js&"
export * from "./SecurityPage.vue?vue&type=script&lang=js&"
import style0 from "./SecurityPage.vue?vue&type=style&index=0&id=09794fb7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports